import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './main';
import reportWebVitals from './reportWebVitals';
import './fonts/nourishe/NourisheInline.ttf';
import { Auth0Provider } from '@auth0/auth0-react';
import { MsalProvider } from '@azure/msal-react';
import ErrorBoundary from './ErrorBoundary';
import { ErrorProvider } from "./ErrorContext";
import config from './config';
import { msalInstance } from './utils/msalInstance';
import { installAuthInterceptor } from './utils/authFetch';

installAuthInterceptor();

// Global error handling to prevent crashes in production
if (process.env.NODE_ENV === "production") {
  console.error = () => {};
  console.warn = () => {};
}
if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "development") {
  window.onerror = function (message, source, lineno, colno, error) {
    console.error("Global Error Caught:", message, error);
    return true; // Prevents the error from being displayed in production
  };

  window.onunhandledrejection = function (event) {
    console.error("Unhandled Promise Rejection:", event.reason);
    return true;
  };
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={msalInstance}>
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onError={(error) => console.error("Auth0 Error:", error)}
    >
      <ErrorProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ErrorProvider>
    </Auth0Provider>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
